import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage } from 'core/yup';

// The most characters a family name has, as the server counts them.
const NAME_MAX_LENGTH = 255;

export const upsertPartFinderFamilySchema = () =>
  yup.object().shape({
    name: yup
      .string()
      .label(t('labelName'))
      .trim()
      .nullable()
      .required(getEmptyErrorMessage(t('labelName')))
      .max(
        NAME_MAX_LENGTH,
        t('errorFieldMaxLength', { field: t('labelName'), length: NAME_MAX_LENGTH })
      ),
    productTypeId: yup
      .number()
      .label(t('labelProductType'))
      .nullable()
      .required(getEmptyErrorMessage(t('labelProductType'))),
    category: yup
      .object()
      .label(t('labelCategories'))
      .nullable()
      .required(getEmptyErrorMessage(t('labelCategories'))),
  });
